<template>

    <div class="pt-8">
        <template>
            <v-overlay :value="loader">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </template>

        <ItemsRecommendedDays 
            :items="itemsOfDay"
            @open-search-item-modal="openSearchModal('item_of_day')" 
            @open-delete-modal="openDeleteModal($event)"
        />

        <hr>

        <recommended-items 
            :items="itemsRecommended"
            @open-search-item-modal="openSearchModal('recommended_item')" 
            @open-delete-modal="openDeleteModal($event)"
        />
           
        <ModalSearchItem
            :openSearchItemModal="openSearchItemModal" 
            :searchData="searchData" 
            @confirm-search="searchItemDetail()" 
            @close-modal="openSearchItemModal = false"
        />

        <RegisterItemRecommended 
            :openRegisterModal="itemRegisterModal" 
            :item="itemRegisterData"
            :item_type="selectedItemType"
            @close-modal="itemRegisterModal = false" 
            @close-add-modal="closeItemModal" 
        />

        <DeleteItem 
            :openDeleteModal="itemDeleteModal"
            :item="itemDeleteData"
            @close-modal="itemDeleteModal = false"
            @close-delete-modal="closeDeleteItemModal"
        />
        
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import RecommendedItems from '../components/RecommendedItemsTable.vue'
import ItemsRecommendedDays from '../components/ItemsOfDayTable.vue'
import ModalSearchItem from '../components/ModalSearchItem.vue'
import RegisterItemRecommended from '../components/RegisterItemRecommended.vue'
import DeleteItem from '../components/DeleteItem.vue'

export default {
    data(){
        
        return{
            itemsRecommended: [],
            itemsOfDay: [],
            loader: false,
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            openSearchItemModal: false,
            searchData:{
                item_reference: ''
            },
            selectedItemType: '',
            pageOptions: "",
            pageSize: [10, 25, 50, 100],
            itemRegisterData: {},
            itemRegisterModal: false,
            itemDeleteModal: false,
            itemDeleteData: {}
        }
    },
    components: {
        RecommendedItems,
        ModalSearchItem,
        RegisterItemRecommended,
        DeleteItem,
        ItemsRecommendedDays
    },

    created(){
        this.getItemsRecommended();
        this.getRecommendedDayItems();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getItemsRecommended(){
            this.setLoading(true)
            await this.$conectar.post('/admin/recommended-items/get-all-recommended-items')
            .then(response =>{
                this.itemsRecommended = response.data.items;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getRecommendedDayItems(){
            this.setLoading(true)
            await this.$conectar.post('/admin/recommended-items/get-recommended-day-items')
            .then(response =>{
                this.itemsOfDay = response.data.items;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getCompanies();
        },
        async searchItemDetail() {
            this.openSearchItemModal = false;
            this.pageOptions = { 
                item_reference:       this.searchData.item_reference,
                item_type:            this.selectedItemType,
            }
            this.setLoading(true)
            await this.$conectar.post('/admin/recommended-items/get-item-details', this.pageOptions)
            .then(response =>{
                if(response.data.error == true){
                    this.$bvToast.toast( `${response.data.message} Código buscado: ${this.searchData.item_reference}`, {
                        title: response.data.title,
                        variant: "warning",
                        solid: true
                    })
                }else{
                    this.openRegisterItemModal(response.data.itemDetail);
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast("Parece que hubo un error al conectar con el servidor", {
                    title: "Error al actualizar la solicitud",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
            this.searchData.item_reference = '';
        },
        openSearchModal(itemType) {
            this.selectedItemType = itemType;
            this.openSearchItemModal = true;
        },
        openRegisterItemModal(item){
            this.itemRegisterModal = true;
            this.itemRegisterData = item;
        },
        closeItemModal(){
            this.itemRegisterModal = false;
            this.selectedItemType = '';
            this.getRecommendedDayItems();
            this.getItemsRecommended();
        },
        openDeleteModal(item){
            this.itemDeleteModal = true;
            this.itemDeleteData = item;
        },
        closeDeleteItemModal(){
            this.itemDeleteModal = false;
            this.getRecommendedDayItems();
            this.getItemsRecommended();
        }
    }
}
</script>